import BaseStore from 'stores/BaseStore';
import { useRootStore } from './useRootStore';

export const useStore = <T extends BaseStore>(name: string) => {
  const rootStore = useRootStore();
  if (!(name in rootStore.stores)) {
    throw new Error(`cannot find store "${name}" in rootstore`);
  }
  return rootStore.stores[name] as T;
};
